/* eslint-disable no-unused-vars */
import React from "react";
import { Modal, Row, Col } from "antd";
import constantsMsgs from "../../constants/messages";
import crossButton from "../../assests/images/CrossButton.svg";
import ServiceNonDox from "./ServiceNonDox";
import "../../commonStyles/crossButton.scss";
import "./style.scss";
// let date = new Date().toLocaleString(undefined, { timeZone: "Asia/Kolkata" });
const BookingSummary = ({ visible, handleCancel = () => {}, allAppData }) => {
  const childAwbNumber = JSON.parse(localStorage.getItem("childAwbNumber"));
  const file = JSON.parse(localStorage.getItem("filesLength"));
  const childAwbNo = childAwbNumber?.map((val) => val);
  const objectDate = new Date();
  const day = objectDate.getDate();
  const month = objectDate.getMonth() + 1;
  const year = objectDate.getFullYear();

  const {
    awbNumber,
    senderCity,
    receiverCity,
    senderName,
    senderAddressLine1,
    senderAddressLine2,
    senderState,
    senderPincode,
    senderAreaName,
    senderMobileNumber,
    receiverName,
    receiverAddressLine1,
    receiverState,
    receiverPincode,
    receiverAreaName,
    receiverMobilenumber,
    type,
    service,
    travelBy,
    senderGst,
    descriptions,
    value,
    Weight,
    eWayBill,
    charges,
    sgst,
    cgst,
    igst,
    cess,
    freight,
  } = allAppData || {};

  return (
    <div>
      {allAppData?.docType === "DOX" ? (
        <Modal
          title="Booking Summary"
          className="booking-summary"
          open={visible}
          width={1000}
          footer={false}
          onCancel={handleCancel}
          maskClosable={false}
          closeIcon={<img src={crossButton} />}
        >
          <div className="modal-content">
            <Row>
              <Col span={24}>
                <Row>
                  <div className="title highlight">
                    <h4>{constantsMsgs?.BOOKING_DETAILS}</h4>
                  </div>
                </Row>
                <Row className="booking-details">
                  <Col md={8} lg={8} xs={12} sm={12}>
                    <div className="col">
                      <p>
                        {constantsMsgs?.AWB_NO} &nbsp;&nbsp;&nbsp;{"  "}
                        <span className="highlight">{awbNumber}</span>
                      </p>
                    </div>
                    <div>
                      <p>{constantsMsgs?.BOOKING_FROM}</p>{" "}
                    </div>
                    <div className="highlight">{senderCity}</div>
                  </Col>
                  <Col md={14} lg={14} xs={12} sm={12}>
                    <div className="col">
                      <p>
                        {constantsMsgs?.BOOKING_DATE}&nbsp;{" "}
                        <span className="highlight">{`${day}.${month}.${year}`}</span>
                      </p>
                    </div>
                    <div>
                      <p>{constantsMsgs?.BOOKING_TO}</p>{" "}
                    </div>
                    <div className="highlight">{receiverCity}</div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="address" gutter={16}>
              <Col>
                <Row>
                  <div className="title">
                    <h4>Address</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card">
                      <div>
                        <h4>{senderName}</h4>
                      </div>
                      <div>
                        <p>
                          {senderCity}, {senderAddressLine1},{" "}
                          {senderAddressLine2} {senderState}, {senderPincode}
                        </p>
                        <p>Area: {senderAreaName}</p>
                        <p>Phone no. {senderMobileNumber}</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card card-one">
                      <div>
                        <h4>{receiverName}</h4>
                      </div>
                      <div>
                        <p>
                          {receiverCity}, {receiverAddressLine1},{" "}
                          {receiverState}, {receiverPincode}
                        </p>
                        <p>Area: {receiverAreaName}</p>
                        <p>Phone no. {receiverMobilenumber}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="service">
              <Col span={24}>
                <Row>
                  <div className="title">
                    <h4>Service Details</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card left-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Type: </p>
                          <p>Service : </p>
                          <p>Travel by : </p>
                          <p>Content : </p>
                          <p className="last"> Sender’s GST number :</p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{type ? type : null}</p>
                          <p>{service}</p>
                          <p>{travelBy}</p>
                          <p>Document</p>
                          <p className="last">{senderGst ? senderGst : ""}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card right-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Description: </p>
                          <p>Value:</p>
                          <p>Weight (Gms) : </p>
                          <p>E-Way Bill No :</p>
                          <p className="last">Uploaded files :</p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{descriptions || ""}</p>
                          <p>{value}</p>
                          <p>{Weight}</p>
                          <p>{eWayBill}</p>
                          <p className="last">{file} attachment(s)</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="payment">
              <Col span={24}>
                <Row>
                  <div className="title">
                    <h4>Payment</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card left-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Total Charges: </p>
                          <p>SGST @ 9% : </p>
                          <p className="last">CGST @ 9% : </p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{charges}</p>
                          <p>{sgst ? sgst : "00.00"}</p>
                          <p className="last">{cgst ? cgst : "00.00"}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card right-card">
                      <Row>
                        <Col span={12} className="key">
                          <p> {constantsMsgs?.IGST}: </p>
                          <p>{constantsMsgs?.CESS} : </p>
                          <p className="last"></p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{igst ? igst : "00.00"}</p>
                          <p>{cess ? cess : "00.00"}</p>
                          <p className="last"></p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col className="frieght-class">
                <p id="frieght"> Freight :</p>
                <p id="frieghtValue">{freight}</p>
              </Col>
            </Row>
          </div>
        </Modal>
      ) : (
        <Modal
          title="Booking Summary"
          className="booking-summary"
          open={visible}
          width={1000}
          footer={false}
          onCancel={handleCancel}
          maskClosable={false}
          closeIcon={<img src={crossButton} />}
        >
          <div className="modal-content">
            <Row>
              <Col span={24}>
                <Row>
                  <div className="title highlight">
                    <h4>Booking Details</h4>
                  </div>
                </Row>
                <Row className="booking-details">
                  <Col md={8} lg={8} xs={12} sm={12}>
                    <div className="col">
                      <p>
                        {constantsMsgs?.AWB_NO} &nbsp;&nbsp;&nbsp;{"  "}
                        <span className="highlight">{awbNumber}</span>
                      </p>
                    </div>
                    <div>
                      <p>{constantsMsgs?.BOOKING_FROM}</p>{" "}
                    </div>
                    <div className="highlight">{senderCity}</div>
                  </Col>
                  <Col md={14} lg={14} xs={12} sm={12}>
                    <div className="col">
                      <p>
                        {constantsMsgs?.BOOKING_DATE}&nbsp;{" "}
                        <span className="highlight">{`${day}.${month}.${year}`}</span>
                      </p>
                    </div>
                    <div>
                      <p>{constantsMsgs?.BOOKING_TO}</p>{" "}
                    </div>
                    <div className="highlight">{receiverCity}</div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="address" gatter={32}>
              <Col>
                <Row>
                  <div className="title">
                    <h4>Address</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card">
                      <div>
                        <h4>{senderName}</h4>
                      </div>
                      <div>
                        <p>
                          {senderCity}, {senderAddressLine1},{" "}
                          {senderAddressLine2} {senderState}, {senderPincode}
                        </p>
                        <p>Area: {senderAreaName}</p>
                        <p>Phone no. {senderMobileNumber}</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card card-one">
                      <div>
                        <h4>{receiverName}</h4>
                      </div>
                      <div>
                        <p>
                          {receiverCity}, {receiverAddressLine1},{" "}
                          {receiverState}, {receiverPincode}
                        </p>
                        <p>Area: {receiverAreaName}</p>
                        <p>Phone no. {receiverMobilenumber}</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* <Row className="service">
              <Col span={24}>
                <Row>
                  <div className="title">
                    <h4>Service Details</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card left-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Type: </p>
                          <p>Service : </p>
                          <p>Travel by : </p>
                          <p>Content : </p>
                          <p>Description: </p>
                          <p> Value (INR) :</p>
                          <p>No of Packets :</p>
                          <p className="last">Child packet tracking no :</p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{allAppData?.type ? allAppData?.type : null}</p>
                          <p>{allAppData?.service}</p>
                          <p>{allAppData?.travelBy}</p>
                          <p>{allAppData?.content}</p>
                          <p>{allAppData?.description || ""}</p>
                          <p>{allAppData?.value}</p>
                          <p>{allAppData?.noOfChildPacket}</p>
                          <p className="last">
                            {allAppData?.child_Selected
                              ? childAwbNo?.join(", ") || ""
                              : ""}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card right-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Weight (Kg) :</p>
                          <p>Length (Cm) :</p>
                          <p>Width (Cm) :</p>
                          <p> Height (Cm) : </p>
                          <p>Vol Weight (Kg) : </p>
                          <p>E-Way Bill No :</p>
                          <p> Sender’s GST number :</p>
                          <p className="last"></p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{allAppData?.weight}</p>
                          <p>{allAppData?.length}</p>
                          <p>{allAppData?.width}</p>
                          <p>{allAppData?.height}</p>
                          <p>{allAppData?.volumetricWeight}</p>
                          <p>{allAppData?.eWayBill}</p>
                          <p>
                            {allAppData?.senderGst ? allAppData?.senderGst : ""}
                          </p>
                          <p className="last right-last">
                            {allAppData?.child_Selected
                              ? childAwbNo?.join(", ") || ""
                              : ""}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row> */}
            <Row>
              <Col span={24}>
                <Row>
                  <div className="title">
                    <h4>Service Details</h4>
                  </div>
                </Row>
              </Col>
            </Row>
            <ServiceNonDox allAppData={allAppData} childAwbNo={childAwbNo} />
            <Row className="payment">
              <Col span={24}>
                <Row>
                  <div className="title">
                    <h4>Payment</h4>
                  </div>
                </Row>
                <Row>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card left-card">
                      <Row>
                        <Col span={12} className="key">
                          <p>Total Charges: </p>
                          <p>SGST @ 9% : </p>
                          <p className="last">CGST @ 9% : </p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{charges}</p>
                          <p>{sgst ? sgst : "00.00"}</p>
                          <p className="last">{cgst ? cgst : "00.00"}</p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col md={12} lg={12} sm={24} xs={24}>
                    <div className="card right-card">
                      <Row>
                        <Col span={12} className="key">
                          <p> {constantsMsgs?.IGST}: </p>
                          <p>{constantsMsgs?.CESS} : </p>
                          <p className="last"></p>
                        </Col>
                        <Col span={12} className="value">
                          <p>{igst ? igst : "00.00"}</p>
                          <p>{cess ? cess : "00.00"}</p>
                          <p className="last"></p>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col className="frieght-class">
                <p id="frieght"> Frieght :</p>
                <p id="frieghtValue">{freight}</p>
              </Col>
            </Row>
          </div>
        </Modal>
      )}
    </div>
  );
};

// BookingSummary.propTypes = {
//   second: PropTypes.third,
// };

export default BookingSummary;
